import React from 'react';
import styles from './Input.module.css';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  icon?: React.ReactNode;
  suffix?: React.ReactNode;
  invalid?: boolean;
  wrapClassName?: string;
  loading?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ icon, suffix, invalid = false, wrapClassName, className, loading = false, ...rest }, ref) => {
    const wrapClasses = [
      styles.wrap,
      invalid ? styles.invalid : '',
      loading ? 'dylo-loading-host' : '',
      wrapClassName || '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div className={wrapClasses}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <input
          ref={ref}
          className={[styles.input, className || ''].filter(Boolean).join(' ')}
          {...rest}
        />
        {suffix}
        {loading && <span className="dylo-loading-sweep dylo-loading-sweep--field" aria-label="Saving" />}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
